<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="LISTA DE SMS" :data="searchedData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="5" :totalPDF="total" :titleReport="titleReport">

            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataInicial" md-immediately v-mask="'##/##/####'">
                                    <label>Data Inicial</label>
                                </md-datepicker>
                            </div>

                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataFinal" md-immediately v-mask="'##/##/####'">
                                    <label>Data Final</label>
                                </md-datepicker>
                            </div>
                            
                            <div class="md-layout-item md-size-15 md-xsmall-size-25">
                                <md-button @click="read()" class="md-site md-block md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                            <div class="md-layout-item md-size-35 md-xsmall-size-100">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <md-input placeholder="Pesquise aqui..." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow" @dblclick="visualizar(item.id)">
                        <md-table-cell class="uppercase" md-label="MENSAGEM" style="width: 30%" md-sort-by='msg'>{{ item.msg }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CELULAR" style="width: 25%" md-sort-by="celular">{{ item.celular }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="TIPO" style="width: 25%" md-sort-by="tipo">{{ item.tipo }}</md-table-cell>                    
                        <md-table-cell class="uppercase" md-label="DATA" style="width: 20%" md-sort-by="data">{{ item.data }}</md-table-cell>                       
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import Swal from "sweetalert2";

export default {
    name: 'NiveisAcessoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {
                situacao_id: 1
            },
            sms: {},
            detalhes: {},
            permissoes: this.$store.state.usuario.permissao,
            titleReport: 'Relatório de SMS.',
            columnsPDF: [60, 40, 40, 40],
            headRowsPDF: ['MENSAGEM', 'CELULAR', 'TIPO', 'DATA'],
            bodyRowsPDF: ['msg', 'celular', 'tipo', 'data'],
            fildsTXT: ['msg', 'celular', 'tipo', 'data'],
            columnsExcel: [

                {
                    label: "MENSAGEM",
                    field: "msg",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CELULAR",
                    field: "celular"
                },
                {
                    label: "TIPO",
                    field: "tipo",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "DATA",
                    field: "data"
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'sms/buscar', this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.celular, item.data, item.descricao, item.msg, item.tipo]).includes(this.toLower(term)))
            }
            return items
        },

        visualizar(id) {           
            let loader = this.openLoader('dots');
            let reterno = this.sms
            this.$http.get(this.$urlAPI + 'sms/visualizar/' + id)
                .then(response => {
                    Swal.fire({
                        title: 'DETALHES DO SMS',
                        html: "<div>" +
                            '<strong>OPERADORA: </strong>' + response.data.operadora + '<br>' +
                            '<strong>STATUS: </strong>' + response.data.descricao + '<br>' +
                            '</div>'
                    })
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },
    },
};
</script>
